import { ConcreteException } from '../exception'

export class GeneralException extends ConcreteException {
  //
}
